import {Component} from '@angular/core';
import {HeaderComponent} from '@app/header/header.component';
import {GoBackDirective} from '@util/directives/go-back.directive';
import {MarkantElementsModule} from '@markant/elements-angular';
import {ToolbarComponent} from '@app/toolbar/toolbar.component';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
  standalone: true,
  imports: [HeaderComponent, GoBackDirective, MarkantElementsModule, ToolbarComponent],
})
export class PrivacyComponent {}
